import { Injectable, signal } from "@angular/core";

export type CreateWizardStep = 0 | 1 | 2 | 3;

export type SignRequestPath = "sendForESignature" | "selfSign";

export type CreateWizardFlow = "standard" | "bulk";

export type FieldStepActionHandlers = {
  back: () => void;
  submit: () => void;
};

@Injectable({
  providedIn: "root",
})
export class CreateFlowStateService {
  readonly pendingPdf = signal<File | null>(null);
  readonly wizardStep = signal<CreateWizardStep>(0);
  readonly wizardFlow = signal<CreateWizardFlow>("standard");
  readonly signRequestPath = signal<SignRequestPath | null>(null);
  /** Hide KAIZEN nav sidebar on Field step (full-width PDF editor). */
  readonly hideLayoutNavSidebar = signal(false);

  private _fieldStepActions: FieldStepActionHandlers | null = null;

  setWizardFlow(flow: CreateWizardFlow): void {
    this.wizardFlow.set(flow);
  }

  setSignRequestPath(path: SignRequestPath | null): void {
    this.signRequestPath.set(path);
  }

  setPendingPdf(file: File | null): void {
    this.pendingPdf.set(file);
  }

  takePendingPdf(): File | null {
    const f = this.pendingPdf();
    this.pendingPdf.set(null);
    return f;
  }

  setWizardStep(step: CreateWizardStep): void {
    this.wizardStep.set(step);
    this.hideLayoutNavSidebar.set(step === 2);
    if (step !== 2) {
      this._fieldStepActions = null;
    }
  }

  registerFieldStepActions(handlers: FieldStepActionHandlers | null): void {
    this._fieldStepActions = handlers;
  }

  triggerFieldStepBack(): void {
    this._fieldStepActions?.back();
  }

  triggerFieldStepSubmit(): void {
    this._fieldStepActions?.submit();
  }

  setHideLayoutNavSidebar(hide: boolean): void {
    this.hideLayoutNavSidebar.set(hide);
  }

  resetWizardStep(): void {
    this.wizardStep.set(0);
    this.wizardFlow.set("standard");
    this.signRequestPath.set(null);
    this.hideLayoutNavSidebar.set(false);
    this._fieldStepActions = null;
  }
}
